import axios from 'axios'
import {frontageApiService} from "@/plugins/frontage-api";
// loading svg files
const baseURL = process.env.VUE_APP_ASSETS_URL ? process.env.VUE_APP_ASSETS_URL : "";
// ['16', '28', '120', 'misc']
//     .map(size => `${baseURL}images/icons/icons-${size}.svg?ver=${Date.now()}`)
//     .map(async icon => {
//       const res = await axios.get(icon)
//       var div = document.createElement("div");
//       div.innerHTML = res.data
//       div.id = 'icons-' + icon
//       div.style = 'display:none;'
//       document.body.appendChild(div);
//     })

// images from frontage
let _images = []

const setFrontageImages = (assets = {}) => {
    _images = flatten(assets.images)
}

const flatten = (obj = {}) => {
    var flattenedObject = {};
    traverseAndFlatten(obj, flattenedObject);

    return Object.keys(flattenedObject).map(k => ({key: k, path: flattenedObject[k]}))
}

const traverseAndFlatten = (currentNode, target, flattenedKey) => {
    for (var key in currentNode) {
        if (currentNode.hasOwnProperty(key)) {
            var newKey;
            if (flattenedKey === undefined) {
                newKey = key;
            } else {
                newKey = flattenedKey + '.' + key;
            }

            var value = currentNode[key];
            if (typeof value === "object") {
                traverseAndFlatten(value, target, newKey);
            } else {
                target[newKey] = value;
            }
        }
    }
}

const getImage = (name) => {
    const res = _images.find(item => item.key.includes(name))
}

const uploadImage = (autoTrigger = false, type) => {
  return frontageApiService.get('cloudinary-upload-image',{type, showClear: true, params: {autoTrigger: autoTrigger}})
}

const getImageUrl = (imagePath, frameId) => {
  return frontageApiService.get('cloudinary-image-url',{imagePath, frameId})
}

export default {
  setFrontageImages,
  getImage,
  uploadImage,
  getImageUrl,
}
